package tta.destinigo.talktoastro.shared.platform

import kotlinx.browser.window

actual fun isJS(): Boolean = true

actual fun openUrlInBrowser(url: String) {
    window.open(url, "_blank") // Opens in a new tab
}